import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=f506bce4&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=js&"
export * from "./addOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=f506bce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f506bce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f506bce4')) {
      api.createRecord('f506bce4', component.options)
    } else {
      api.reload('f506bce4', component.options)
    }
    module.hot.accept("./addOrEdit.vue?vue&type=template&id=f506bce4&scoped=true&", function () {
      api.rerender('f506bce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerMapping/components/addOrEdit.vue"
export default component.exports